import {
  getPaymentMethodsEndpoints,
  IGetPaymentMethodsDTO,
  IGetPaymentMethodsResponse,
  IUpdatePaymentMethodDTO,
  IUpdatePaymentMethodResponse,
  staticPaymentMethodsEndpoints,
} from '@/models/paymentMethod.model';
import { httpClient, ApiResponse } from '@/utils';

class PaymentMethodsAPI {
  static getPaymentMethods({ channelId }: IGetPaymentMethodsDTO): ApiResponse<IGetPaymentMethodsResponse> {
    const { GET_PAYMENT_METHODS } = staticPaymentMethodsEndpoints;
    return httpClient.get<IGetPaymentMethodsResponse>(GET_PAYMENT_METHODS, {
      params: {
        channelId,
      },
    });
  }

  static updatePaymentMethod(data: IUpdatePaymentMethodDTO): ApiResponse<IUpdatePaymentMethodResponse> {
    const { UPDATE_PAYMENT_METHOD } = getPaymentMethodsEndpoints({ paymentMethodId: data.id });
    return httpClient.patch<IUpdatePaymentMethodResponse>(UPDATE_PAYMENT_METHOD, data);
  }
}

export default PaymentMethodsAPI;
